import { AsyncPipe } from '@angular/common';
import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { TradeConfirmPageBase } from '@zero/trade/feature-trade/base';
import { TradeConfirmButtonComponent } from '../../components/trade-confirm-button/trade-confirm-button.component';
import { TradeConfirmDataComponent } from '../../components/trade-confirm-data/trade-confirm-data.component';
import { TradeConfirmHintComponent } from '../../components/trade-confirm-hint/trade-confirm-hint.component';
import { TradeConfirmLinksComponent } from '../../components/trade-confirm-links/trade-confirm-links.component';
import { TradeConfirmQuoteComponent } from '../../components/trade-confirm-quote/trade-confirm-quote.component';

@Component({
  selector: 'trade-confirm',
  templateUrl: './trade-confirm.component.html',
  imports: [
    TradeConfirmQuoteComponent,
    TradeConfirmDataComponent,
    TradeConfirmHintComponent,
    TradeConfirmLinksComponent,
    TradeConfirmButtonComponent,
    AsyncPipe,
    TranslocoPipe,
  ],
})
export class TradeConfirmComponent extends TradeConfirmPageBase implements OnInit, OnDestroy {
  @Output() public goNext = new EventEmitter<void>();
  @Output() public goBack = new EventEmitter<void>();

  public async ngOnInit(): Promise<void> {
    await super.init();
    if (!this.isReady) {
      this.goBack.emit();
    }
  }

  public ngOnDestroy(): void {
    super.destroy();
  }

  protected override handleSuccessfulTrade(): void {
    this.goNext.emit();
  }
}
